import React from 'react';
import {ScrollView, StyleSheet, TouchableOpacity, useWindowDimensions, View} from 'react-native';

import Button from '../../../components/themed/Button';
import Text from '../../../components/ui-controls/Text';
import {AppRoute} from '../../../models/AppRoute';
import theme from '../../../style/theme';

import NotFoundTicketIcon from './NotFoundTicketIcon';

type OfferNotFoundProps = {
  navigation: {
    navigate: (route: string) => void;
  };
};

const OfferNotFound = ({navigation}: OfferNotFoundProps) => {
  const {width} = useWindowDimensions();
  const isSmallScreen = width < 380;

  return (
    <ScrollView contentContainerStyle={styles.scrollContainer} showsVerticalScrollIndicator={false}>
      <View style={styles.container}>
        <NotFoundTicketIcon
          width={isSmallScreen ? 120 : 144}
          height={isSmallScreen ? 80 : 96}
          color={theme.colour.general.secondary}
        />

        <Text style={[styles.headline, isSmallScreen && styles.headlineSmall]}>
          THIS EXCLUSIVE OFFER HAS FINISHED
        </Text>

        <Text style={[styles.description, isSmallScreen && styles.descriptionSmall]}>
          Looks like this offer has ended or is no longer available.{'\n'}
          Don&apos;t worry - we&apos;ve got plenty of other great deals for you.
        </Text>

        <View style={styles.buttonContainer}>
          <Button
            title="View current exclusive offers"
            onPress={() => navigation.navigate(AppRoute.EXCLUSIVE_OFFER_LIST)}
            buttonStyle={styles.primaryButton}
          />
          <View style={styles.buttonSpacer} />
          <Button
            title="See all promotions"
            onPress={() => navigation.navigate(AppRoute.PROMOTIONS_CURRENT)}
            buttonStyle={styles.primaryButton}
            type="outline"
          />
        </View>

        <TouchableOpacity
          onPress={() => navigation.navigate(AppRoute.HOME)}
          style={styles.linkContainer}
          hitSlop={{top: 10, bottom: 10, left: 10, right: 10}}>
          <Text style={styles.link}>Go to Home</Text>
        </TouchableOpacity>
      </View>
    </ScrollView>
  );
};

export default OfferNotFound;

const styles = StyleSheet.create({
  scrollContainer: {
    flexGrow: 1,
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
    paddingVertical: 32,
    minHeight: 400,
  },
  headline: {
    fontSize: 18,
    fontWeight: 'bold',
    color: theme.colour.text.heading.primary,
    textAlign: 'center',
    marginTop: 24,
    marginBottom: 16,
  },
  headlineSmall: {
    fontSize: 16,
  },
  description: {
    fontSize: 14,
    color: theme.colour.text.content.primary,
    textAlign: 'center',
    lineHeight: 22,
    marginBottom: 32,
    paddingHorizontal: 8,
  },
  descriptionSmall: {
    fontSize: 13,
    lineHeight: 20,
  },
  buttonContainer: {
    width: '100%',
    maxWidth: 300,
    alignItems: 'center',
  },
  buttonSpacer: {
    height: 12,
  },
  primaryButton: {
    width: '100%',
  },
  linkContainer: {
    marginTop: 24,
    paddingVertical: 8,
  },
  link: {
    fontSize: 14,
    color: theme.colour.text.link.primary,
    textDecorationLine: 'underline',
  },
});
